import { css, type Theme } from "@emotion/react";

import { animation, fadeIn } from "@styles/emotion-styles/animations";
import * as dimensions from "@styles/emotion-styles/dimensions";
import { ellipsesOverflowHelper } from "@styles/emotion-styles/helpers/ellipsesOverflowHelper/ellipsesOverflowHelper";
import * as timing from "@styles/emotion-styles/timing";

export const ingredient = css`
  ${animation(fadeIn, timing.slow)};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  margin-block: 0.5rem;

  @media (min-width: ${dimensions.phoneLarge}) {
    margin-block: 0.25rem;
  }
`;

export const withIndent = css`
  margin-left: 1.25rem;
`;

export const productIcon = css`
  margin-left: -1.25rem;
`;

export const iconForChild = css`
  margin-left: -2rem;
`;

export const name = css`
  text-transform: lowercase;
  &::first-letter {
    text-transform: capitalize;
  }
  flex: auto;
  @media (max-width: ${dimensions.phoneLarge}) {
    ${ellipsesOverflowHelper}
  }
`;

export const oldName = css`
  text-transform: capitalize;
  flex: 1.5;
`;

export const button = (theme: Theme) => css`
  color: ${theme.system.textLabelEmphasis};
  margin: 0;
  background: transparent;
  border: 0;
  border-radius: ${dimensions.circleRadius};
  flex: 0 0 44px;
`;

export const oldButton = css`
  flex: auto;
`;

export const amount = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  white-space: nowrap;
  flex: 0 0 116px;
  @media (max-width: ${dimensions.phoneLarge}) {
    flex: 0 0 50px;
  }
`;

export const oldAmount = css`
  flex: 1;
  @media (min-width: ${dimensions.tablet}) {
    margin-left: 2rem;
    min-width: 5rem;
  }

  @media (min-width: ${dimensions.widescreen}) {
    margin-left: 4rem;
  }
`;

export const amountContent = css`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
